import { GraphQLTaggedNode } from 'relay-runtime';
import { useReadFragmentInterop } from './useReadFragmentInterop.ts';
import { FragmentRef } from './useFragmentizedQuery.ts';

export const useFragmentizedFragment = <TFragmentData>(
	fragmentNode: GraphQLTaggedNode,
	fragmentRef: FragmentRef,
): TFragmentData => {
	const readFragmentInterop = useReadFragmentInterop<TFragmentData>({
		fragmentSpec: fragmentNode,
	});

	return readFragmentInterop({
		id: `${fragmentRef?.__typename}:${fragmentRef?.id}`,
	}) as TFragmentData;
};
